import React from 'react';

const ScrollSpacer = ({unit}) => {
    return (
        <div style={{height: unit*2.25, width: '100%'}}></div>
    );
};

export default ScrollSpacer;


// WEBPACK FOOTER //
// ./src/Components/Theme/Miami/ScrollSpacer.js